import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import Dialog from 'global/guides/Dialog'
import { useParams } from 'react-router-dom'
import { useRelatorioDescontoDsrOutletContext } from './RelatorioDescontoDSRCliente'

export default function DetalhesDescontoDSR() {
    const { data } = useRelatorioDescontoDsrOutletContext()
    const { id } = useParams()

    const itemsDoFuncionario =
        data?.filter(
            item =>
                String(item.funcionarioId) === String(id) ||
                String(item.Funcionario?.id) === String(id) ||
                String(item.id) === String(id),
        ) ?? []

    const primeiro = itemsDoFuncionario[0]
    const nomeFuncionario = primeiro?.Funcionario?.nome

    const rows =
        primeiro?.detalhes && primeiro.detalhes.length > 0
            ? primeiro.detalhes.map((item: any, idx: number) => ({
                  ...item,
                  id: idx,
              }))
            : itemsDoFuncionario.map((item, idx) => ({
                  id: item.id ?? idx,
                  data: item.data,
                  valor: item.valor,
              }))

    return (
        <Dialog.Root>
            <Dialog.Title>{nomeFuncionario}</Dialog.Title>
            <Dialog.Content>
                <ContentGuide.DataGrid
                    loading={false}
                    columns={[
                        {
                            field: 'data',
                            headerName: 'Data',
                            type: 'date',
                            valueFormatter: ({ value }) =>
                                dayjs.utc(value).format('DD/MM/YYYY'),
                            flex: 1,
                        },
                        {
                            field: 'valor',
                            headerName: 'Valor descontado',
                            flex: 1,
                        },
                    ]}
                    rows={rows}
                    ToolbarProps={{ hideToolbar: true }}
                    hideFooter
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
